export enum TrashSystemsColumnKeys {
  Name = 'name',
  Reason = 'removalReason',
  UpdatedBy = 'updatedBy',
  LastUpdate = 'lastUpdate',
}